import { __assign, __rest } from "tslib";
/* eslint-disable no-nested-ternary */
import React, { useCallback } from 'react';
import { cnTabsMenu } from '../TabsMenu';
import './TabsMenu-Tab.css';
var Tab = function (props) {
    var id = props.id, innerRef = props.innerRef, active = props.active, className = props.className, content = props.content, disabled = props.disabled, first = props.first, onClick = props.onClick, onInternalClick = props.onInternalClick, otherProps = __rest(props, ["id", "innerRef", "active", "className", "content", "disabled", "first", "onClick", "onInternalClick"]);
    var handleClick = useCallback(function (e) {
        onClick && onClick(e);
        onInternalClick && onInternalClick(id);
        // TODO ISL-10952: разобраться почему не все необходимые переменные указаны в deps и убрать игнор
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, onClick]);
    return (React.createElement("li", __assign({}, otherProps, { "aria-selected": active, ref: innerRef, className: cnTabsMenu('Tab', {
            active: active,
            disabled: disabled,
            first: first,
        }, [className]), role: "tab", 
        // На активном пункте устанавливаем tabIndex 0, чтобы иметь возможность
        // сфокусироваться с клавиатуры именно в него, у остальных пунктов устанавливаем -1,
        // чтобы они не участвовали в навигации.
        tabIndex: disabled ? undefined : active ? 0 : -1, onClick: disabled ? undefined : handleClick }), content));
};
export var TabsMenuTab = React.memo(Tab);
